/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import * as EmailValidator from 'email-validator';
import {
  ERR_EMAIL,
  ERR_EMAIL_INVALID,
  LABEL_BTN_CANCEL,
  NEW_USER_ERROR_INVALID_FIRST_NAME,
  NEW_USER_ERROR_INVALID_LAST_NAME,
  ORG_ADMIN_PLACEHOLDER_EMAIL,
  ORG_ADMIN_PLACEHOLDER_FIRST_NAME,
  ORG_ADMIN_PLACEHOLDER_LAST_NAME,
  UPDATE_USER_ERROR_FIRST_NAME,
  UPDATE_USER_ERROR_LAST_NAME,
} from 'src/constants/constant';
import {
  TextField,
  Autocomplete,
} from '@mui/material';
import { addUserData } from 'src/services/userService';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { getAllRoles } from 'src/services/roleService';
import { getAllClientData } from 'src/services/clientService';
import '../Styles/muiglobal.css';
import { useSelector } from 'react-redux';
import type {
  RootState,
  UserFormInputs,
  Role,
  PropsType,
  RoleApiResponse,
  Client,
  ClientApiResponse,
  appConfigs,
} from '../types/types';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';


function AddUserForm({ closeModal, refreshPage }: PropsType): JSX.Element {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [roles, setRoles] = useState<Role[]>([]);
  const [clients, setClient] = useState<Client[]>([]);
  const [filteredSubClients, setFilteredSubClients] = useState<Client[]>([]);
  const [clientId, selectedClientId] = useState<number>(0);
  const [clientUserId, setClientUserId] = useState<string>("");  
  const [selectedRole, setSelectedRole] = useState<Role | null>(null);
  const { user } = useSelector((state: RootState) => state.auth);
  const storedAppConfig = localStorage.getItem('appConfigs');
  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .transform((value) => value.trim())
    .required(UPDATE_USER_ERROR_FIRST_NAME)
    .matches(
      /^[a-zA-Z](?:[a-zA-Z -]*[a-zA-Z])?$/,
      NEW_USER_ERROR_INVALID_FIRST_NAME
    ), // No apostrophes

  lastName: Yup.string()
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .transform((value) => value.trim())
    .required(UPDATE_USER_ERROR_LAST_NAME)
    .matches(
      /^[a-zA-Z](?:[a-zA-Z -]*[a-zA-Z])?$/,
      NEW_USER_ERROR_INVALID_LAST_NAME
    ),
    email: Yup.string()
      .required(ERR_EMAIL)
      .email(ERR_EMAIL_INVALID)
      .test(
        'is-valid-email',
        ERR_EMAIL_INVALID,
        (value) => value === '' || EmailValidator.validate(value),
      ),
      roleId: Yup.number().required('Please enter the role'),
    
      clientId: Yup.number().when(['$userRoleId', '$selectedRole'], {
        is: (userRoleId: number, selectedRole: Role | null) =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
          user?.isClientRole === false && selectedRole && selectedRole.isClientRole === true,
        then: (schema) => schema.required('Please enter the client'),
        otherwise: (schema) => schema.notRequired(),
      }),
    });
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<UserFormInputs>({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    resolver: yupResolver(validationSchema),
    context: { 
      userRoleId: user?.roleID,
      selectedRole: selectedRole
     },
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
    },
  });
console.log('user', clientUserId);
  useEffect(() => {
    setIsLoading(true);
    getAllClientData()
      .then((response: ClientApiResponse): void => {
        console.log(response);
        if (response.status === 200) {
          const activeClients = response.data.data.filter(
            (client: { isActive: boolean }) => client.isActive
        );

        setClient(activeClients);  
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
          if(user?.clientId != undefined && user?.clientId != 0 && user?.roleName !== 'Super Admin' ){
            selectedClientId(user?.clientId);
          const subClients = response.data.data.filter((client) => client.parentId === user?.clientId);
          setFilteredSubClients(subClients);
          console.log(subClients);
          }
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log('Error in fetching users: ', error);
        setIsLoading(false);
    });
      console.log(user?.clientId);

        if (storedAppConfig !== null && storedAppConfig !== '') {
            try {
              const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];
              const clientUserId = parsedAppConfig.find(
                (item) => item.configName === 'Client User',
              )?.configValue;
              if (clientUserId != null) {
                setClientUserId(clientUserId);
              }
            } catch (error) {
              console.error('Error parsing appConfig data:', error);
            }
          }
      
  }, []);
  useEffect(() => {
    if (roles.length == 0) {
      getAllRoles(user?.roleID)
        .then((response: RoleApiResponse) => {
          if (response.status === 200) {
            const roleListArr: Role[] = [];
            response.data.data.map((role: Role) => {
              roleListArr.push(role);
            });
            setRoles(roleListArr);
          }
        })
        .catch((error) => console.log('Error in fetching roles: ', error));
    }
  }, [roles]);
  const handleClientClick = (value: number): void => {
    selectedClientId(value);
    const subClients = clients.filter((client) => client.parentId === value);
    setFilteredSubClients(subClients);
  };

  const onSubmit = async (data: UserFormInputs): Promise<void> => {
   
    const requestData = {
      ...data,
      clientId: clientId, // Use clientId
      createdBy: user?.id, // Add createdBy field
    };
  
    console.log('Transformed Request Data:', requestData);

    setIsLoading(true);

    try {
      const res = await addUserData(requestData);

      if (res.status === 200) {
        if (res.data.result === 1) {
          NotificationManager.success('User created successfully');
          refreshPage();
        } else if (res.data.messages === 'Email address exists in the system') {
          NotificationManager.error('Email address already exists');
        }else {
                      NotificationManager.error(res.data.messages);
                    }
      }
    } catch (error) {
      console.error('Error occurred:', error);
      NotificationManager.error('Unknown error has occurred');
    } finally {
      setIsLoading(false);
    }
  };
  console.log(user?.roleID);
  console.log(isLoading);
  return (
    <React.Fragment>
       {
                isLoading ?
                    <div className='flex justify-center items-center relative '><span className="loading loading-spinner text-primary"></span></div> :
      <form
        onSubmit={(e) => {
          e.preventDefault();
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          void handleSubmit(onSubmit)(e);
        }}
      >
        <div className="relative px-[16px] pt-[10px]">
          <div className="mb-[30px]">
            <Controller
              name="firstName"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <>
                <TextField
                  {...field}
                  fullWidth
                  label="First Name*"
                  autoComplete="off"
                  placeholder={ORG_ADMIN_PLACEHOLDER_FIRST_NAME}
                  error={Boolean(errors.firstName)}
                  // helperText={errors.firstName?.message}
                />
                {errors.firstName && (
                  <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                    {errors.firstName?.message} {/* Show the error message */}
                  </div>
                )}
                </>
              )}
            />
          </div>
          <div className="mb-[30px]">
            <Controller
              name="lastName"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <>
                <TextField
                  {...field}
                  fullWidth
                  label="Last Name*"
                  autoComplete="off"
                  placeholder={ORG_ADMIN_PLACEHOLDER_LAST_NAME}
                  error={Boolean(errors.lastName)}
                  // helperText={errors.lastName?.message}
                />
                {errors.lastName && (
                  <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                    {errors.lastName?.message} {/* Show the error message */}
                  </div>
                )}
                </>
              )}
            />
          </div>
          <div className="mb-[30px]">
            <Controller
              name="email"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <>
                <TextField
                  {...field}
                  fullWidth
                  label="Email*"
                  autoComplete="off"
                  placeholder={ORG_ADMIN_PLACEHOLDER_EMAIL}
                  error={Boolean(errors.email)}
                  // helperText={errors.email?.message}
                />
                {errors.email && (
                  <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                    {errors.email?.message} {/* Show the error message */}
                  </div>
                )}
                </>
              )}
            />
          </div>
         
          <div className="mb-[30px]">
            <Controller
              name="roleId"
              control={control}
              render={({ field }) => (
                <>
                <Autocomplete
                  options={roles} // The list of roles
                  getOptionLabel={(option) => option.roleName} // Display roleName
                  popupIcon={
                    <HugeiconsIcon
                      icon={ArrowDown01Icon}
                      size={18}
                      color="#3A3A3A"
                      strokeWidth={0.2}
                
                    />
                  }
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  //@ts-ignore
                  isOptionEqualToValue={(option, value) => option.roleId === value} // Match by roleId
                  value={roles.find((role) => role.roleId === field.value)} // Current value matching
                  onChange={(_, selectedRole) => {
                    const roleId = selectedRole?.roleId;
                    setSelectedRole(selectedRole); // store selectedRole for Yup context
                    field.onChange(roleId); // update form state
                  }}
                  
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Role*"
                      placeholder="Select role"
                      error={Boolean(errors.roleId)}
                      // helperText={errors.roleId?.message}
                    />
                  )}
                  disableClearable // Prevent the clear button
                />
                {errors.roleId && (
                  <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                    {errors.roleId?.message} {/* Show the error message */}
                  </div>
                )}
                </>
              )}
            />
          </div>
          
          {// eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          user?.isClientRole === false && selectedRole?.isClientRole === true && (
            <>
   <div className="mb-[30px]">
   <Controller
     name="clientId"
     control={control}
     render={({ field }) => (
       <Autocomplete
         options={clients}
         getOptionLabel={(option) => option.clientName}
         popupIcon={
           <HugeiconsIcon
             icon={ArrowDown01Icon}
             size={18}
             color="#3A3A3A"
             strokeWidth={0.2}
         
           />
         }
         isOptionEqualToValue={(option, value) => option.id === value.id}
         value={clients.find((client) => client.id === field.value)}
         onChange={(_, selectedClient) => {
           const clientId = selectedClient?.id;
           handleClientClick(Number(clientId));
           field.onChange(clientId);
         }}
         renderInput={(params) => (
           <TextField
             {...params}
             label="Client"
             placeholder="Select client"
             error={Boolean(errors.clientId)}
             helperText={errors.clientId?.message}
           />
         )}
         disableClearable
       />
     )}
   />
 </div>

          

          {filteredSubClients.length > 0 && (
            <div className="mb-[30px]">
            <Controller
              name="subClientId"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  options={filteredSubClients} // The list of filtered subclients
                  getOptionLabel={(option) => option.clientName} // Display clientName for options
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  //@ts-ignore
                  isOptionEqualToValue={(option, value) => option.id === value} // Match by ID
                  value={filteredSubClients.find((subClient) => subClient.id === field.value)} // Match current value
                  onChange={(_, selectedSubClient) => {
                    const subClientId = selectedSubClient?.id ; // Handle null case
                    console.log('Selected subclient:', subClientId);
                    field.onChange(subClientId); // Update form state
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Subclient"
                      placeholder="Select subclient"
                      error={Boolean(errors.subClientId)}
                      helperText={errors.subClientId?.message}
                    />
                  )}
                  disableClearable // Prevent clearing the input with a clear button
                />
              )}
            />
          </div>
          
          )}
          </>
        )}
        </div>
        <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
          <div className="w-full relative col-span-3">
            <button
              type="button"
              className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted"
              disabled={isLoading}
              onClick={closeModal}
            >
              {LABEL_BTN_CANCEL}
            </button>
          </div>
          <div className="w-full relative col-span-3">
            <button
              type="submit"
              className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]"
            >
              {!isLoading ? (
                'Save'
              ) : (
                <span className="loading loading-spinner loading-xs text-white"></span>
              )}
            </button>
          </div>
        </div>
      </form>
}
    </React.Fragment>
  );
}

export default AddUserForm;